/* eslint-disable react/prop-types */
import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  Link,
  Typography
} from '@one-thd/sui-atomic-components';
import { CartPrice } from './CartPrice';
import { Image } from './Image';

const Summary = ({
  id,
  product,
  quantity,
  onLink = () => {}
}) => {
  const {
    identifiers, pricing
  } = product || {};
  return (
    <ErrorBoundary name={`moreLikeThis-product-${id}`}>
      <div
        data-automation-id={`moreLikeThis-product-${id}`}
        className="sui-grid sui-grid-cols-12 sui-mx-4 sui-py-4"
      >
        {/* item image */}
        <div
          data-automation-id={`moreLikeThis-product-image-${id}`}
          className="sui-col-span-3 sm:sui-col-span-3"
        >
          <Link
            className="sui-no-underline"
            href={identifiers?.canonicalUrl}
            target="_top"
            onClick={onLink}
          >
            <Image product={product} />
          </Link>
        </div>
        {/* item description */}
        <div
          data-automation-id={`moreLikeThis-product-summary-${id}`}
          className="sui-col-span-8 sm:sui-col-span-8 sui-pl-4"
        >
          <Typography>
            <Link
              className="sui-no-underline"
              href={identifiers?.canonicalUrl}
              target="_top"
              onClick={onLink}
            >
              <div className="sui-font-bold">{identifiers?.brandName}</div>
              <div>{' ' + identifiers?.productLabel}</div>
            </Link>
            <>
              {quantity && (
                <div className="sui-pt-2">
                  Qty: {quantity}
                </div>
              )}
            </>
            {/* item price */}
            <CartPrice
              pricing={pricing}
              quantity={quantity}
            />
          </Typography>
        </div>
      </div>
      <hr className="sui-mx-4 sui-my-1" />
    </ErrorBoundary>
  );
};

Summary.propTypes = {};

Summary.displayName = 'Summary';

export { Summary };
